import React, { ReactElement } from 'react';
import styled from 'styled-components';

import { Flex, Copyright, Typography } from 'components';
import { useSchool } from 'features/school';

export const Wrapper = styled(Flex)`
  flex-direction: column;
`;

const LinkHP = styled(Typography)`
  &:hover {
    color: white;
  }
`;

const MainFooter = (): ReactElement => {
  const { schoolMelver } = useSchool();

  return (
    <Flex as="footer" bg="dark_400" flexDirection="column">
      <Flex py={{ m: 15, d: 20 }}>
        <Flex justifyContent="center" alignItems="center">
          <Copyright />
          {schoolMelver && (
            <>
              <Typography type="type0" color="white50" mx={1}>
                •
              </Typography>
              <LinkHP
                type="type0"
                color="white50"
                onClick={() => {
                  window.open(
                    '/hp',
                    'hp',
                    'resizable=0, height=375, width=600, left=' + (window.innerWidth - 600) / 2 + ', top=' + (window.innerHeight - 375) / 2
                  );
                }}
                style={{ cursor: 'pointer', textDecoration: 'underline' }}
              >
                HP Virtual
              </LinkHP>
            </>
          )}
        </Flex>
      </Flex>
    </Flex>
  );
};
export default MainFooter;
